export class api {
    serverPath: string = 'https://pinsouqstore.com/wp/v2/';
}